import { Routes, Route, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect } from "react";

import Profile from "../auth/user/profile";
import Players from "../auth/user/players/players";
import PlayerMenu from "../auth/user/players/playerCrud/playerMenu";
import AddStats from "../auth/user/players/playerCrud/addStats/addStats";
import News from "./News/news";
import NewsAll from "./News/NewsAll";
import Ranking from "./Ranking/ranking";
import Register from "./signup/signup";
import PageNotFound from "../../pageNotFound/pageNotFound";
import Player from "./Player/Player";
import BuyCredits from "../auth/user/buyCredits/buyCredits";
import Guild from "./Guild/Guild";
import GuildsAll from "./Guild/GuildsAll";
import Commands from "./News/Commands/commands";
import GameInfo from "./News/GameInfo/gameInfo";
import BuyItems from "./News/BuyItems/buyItems";
import EventsTimes from "../centerPages/News/Events/events";
import DownloadBox from "./Download/Download";
import ChangePassword from "../auth/user/changePassword/changePassword";
import ChangeEmail from "../auth/user/ChangeMail/changeMail";
import Guides from "./Guides/Guides";
import PanelFrame from "../ui/PanelFrame";
import "./center.scss";

const CenterPage = () => {
  const location = useLocation();
  const userAuth = useSelector((state) => state.reducerUser.userLogin);
  const isHome = location.pathname === "/";
  const isCustomLayout =
    location.pathname === "/news" ||
    location.pathname === "/guilds" ||
    location.pathname.startsWith("/guides");

  useEffect(() => {
    if (location.pathname === "/") {
      window.scrollTo(0, 0);
    }
  }, [location]);

  const routes = (
    <Routes>
      <Route path="/">
        <Route path="/" element={<News />} />
        <Route path="/news" element={<NewsAll />} />
        <Route path="/guides" element={<Guides />} />
        <Route path="/ranking" element={<Ranking />} />
        <Route path="/player/:id" element={<Player />} />
        <Route path="/guilds" element={<GuildsAll />} />
        <Route path="/guild/:guildname" element={<Guild />} />
        <Route path="/events" element={<EventsTimes />} />
        <Route path="/commands" element={<Commands />} />
        <Route path="/gameInfo" element={<GameInfo />} />
        <Route path="/buyitems" element={<BuyItems />} />
        <Route
          path="/download"
          element={
            <DownloadBox url="https://mega.nz/file/ApQGkb5L#LcwOLPJ46IO1Q2tIfzYEtJXYzmqALhJUXsnAwpcCpOo" />
          }
        />

        {userAuth.status == "fulfilled" ? (
          <>
            <Route path="/profile" element={<Profile user={userAuth} />} />
            <Route
              path="/buyCredits"
              element={<BuyCredits user={userAuth} />}
            />
            <Route path="/players" element={<Players user={userAuth} />} />
            <Route
              path="/player/playerMenu/:id"
              element={<PlayerMenu userAuth={userAuth} />}
            />
            <Route
              path="/player/addStats/:id"
              element={<AddStats user={userAuth} />}
            />
            <Route
              path="/player/changePassword"
              element={<ChangePassword user={userAuth} />}
            />
            <Route
              path="/player/changeEmail"
              element={<ChangeEmail user={userAuth} />}
            />
          </>
        ) : (
          <Route path="/register" element={<Register />} />
        )}
        <Route path="*" element={<PageNotFound />} />
      </Route>
    </Routes>
  );

  if (isHome) {
    return <div style={{ display: "none" }}>{routes}</div>;
  }

  if (isCustomLayout) {
    return <div className="mu-center mu-center--bleed">{routes}</div>;
  }

  return (
    <PanelFrame title="Mu Beginning" className="mu-center-panel">
      <div className="mu-center">{routes}</div>
    </PanelFrame>
  );
};

export default CenterPage;
